export const Trade = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <path
          d='M17.5 21.5L16 20M16 20L17.5 18.5M16 20H18C19.6569 20 21 18.6568 21 17M6.5 3.49997L8 4.99997M8 4.99997L6.5 6.49997M8 4.99997H6C4.34315 4.99997 3 6.34312 3 7.99997M11 8.99997V7.29988C11 6.84419 11.2072 6.41322 11.563 6.12856L15.063 3.32866C15.6108 2.89045 16.3892 2.89045 16.937 3.32866L20.437 6.12856C20.7928 6.41322 21 6.84419 21 7.29988V11.5C21 12.3284 20.3284 13 19.5 13H15M3.563 14.1286L7.063 11.3287C7.61081 10.8904 8.38919 10.8904 8.937 11.3287L12.437 14.1286C12.7928 14.4132 13 14.8442 13 15.2999V19.5C13 20.3284 12.3284 21 11.5 21H4.5C3.67157 21 3 20.3284 3 19.5V15.2999C3.00001 14.8442 3.20716 14.4132 3.563 14.1286Z'
          stroke='currentcolor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
